import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';



const EXCLUDED_URL_SUBSTRINGS = [
  '/cotizacion/SURA_OrquestadorAsesores',
  '/tarifas/planes',
  '/clientes/membresiaservice',
  '/clientes/autos/cotizacion',
  'startsarlaftevaluation',
  'pullersarlaft',
  '/clientes/exceptionMovilidad',
];

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const isExcluded = EXCLUDED_URL_SUBSTRINGS.some((substring) => req.url.includes(substring));

      if (!isExcluded) {
        if (error.status >= 500) {
          void router.navigate(['/fin-de-flujo/error-500'], {
            queryParams: { codigo: error.status },
          });
        } else if (error.status >= 400) {
          void router.navigate(['/fin-de-flujo/error-404'], {
            queryParams: { codigo: error.status },
          });
        } else if (error.status === 0) {
          void router.navigate(['/fin-de-flujo/conexion'], { state: { returnUrl: router.url } });
        }
      }

      const errorMessage = resolveErrorMessage(error);
      return throwError(() => new Error(errorMessage));
    }),
  );
};

/** Determina el mensaje de error según el tipo de fallo */
function resolveErrorMessage(error: HttpErrorResponse): string {
  if (error.status === 0) {
    // Error de red (sin conexión, CORS, etc.)
    return 'Error de conexión. Por favor verifica tu conexión a internet.';
  }

  // Los mensajes de error por código de estado se definirán
  // junto al equipo de backend
  return error.message || 'Ha ocurrido un error inesperado.';
}
